import React, {useState} from 'react';
import {BackButton, ButtonArea, OkButton} from '../../shared/components/Buttons';
import { formatCurrency } from '../../../data/shared/money';
import {withTranslation} from "react-i18next";
import Modal from "../../shared/components/Modal";

const AcceptQuotationForm = ({ data, isLoading, onSubmit, onClickCancel, t }) => {
    const [open, setOpen] = useState(true);

    const handleCancel = (open) => {
        setOpen(open)
        onClickCancel()
    }

    return <Modal open={open} hideClose={true} setOpen={handleCancel} title={t('followup.confirmation')}>
        <div className="inner">

            <p className="mt-10">{t('followup.confirmation_information_1')}</p>

            <p className="my-5">
                {t('followup.confirmation_information_2')}{' '}
                {data && formatCurrency(data.pricing.totalWithTaxes)} {t('followup.all_taxes_included')}.
            </p>

            <p className="mb-10">
                <small>Sous réserve de disponibilité au moment de l'acceptation de devis.</small>
            </p>

            <ButtonArea>

                <BackButton disabled={isLoading} onClick={()=>{handleCancel(false)}}>{t('followup.back_to_demand')}</BackButton>
                <OkButton
                    type="button"
                    disabled={isLoading}
                    loading={isLoading}
                    className="ml-auto"
                    onClick={onSubmit}
                >
                    {t('followup.accept_quotation')}
                </OkButton>

            </ButtonArea>

        </div>
    </Modal>
};

export default withTranslation()(AcceptQuotationForm);
